import { render, staticRenderFns } from "./BlongPlate.vue?vue&type=template&id=20b4d562&scoped=true"
import script from "./BlongPlate.vue?vue&type=script&lang=js"
export * from "./BlongPlate.vue?vue&type=script&lang=js"
import style0 from "./BlongPlate.vue?vue&type=style&index=0&id=20b4d562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4d562",
  null
  
)

export default component.exports